import client from "./client";
import { Term, SurveyType } from "@/interfaces";

export const getTerms = () => client.get<{ TermResult: Term[] }>("terms");

export const deleteTerm = (termId: number) => client.delete(`terms/${termId}`);

export const addTerm = (term: Term, onUploadProgress: (progressEvent: ProgressEvent) => void) =>
  client.post<{ TermResult: Term }>("terms", { ...term }, onUploadProgress);

export const updateTerm = (term: Term, onUploadProgress: (progressEvent: ProgressEvent) => void) =>
  client.put<{ TermResult: Term }>(`terms/${term.id}`, { ...term }, onUploadProgress);

export const getTermsBySection = (section: SurveyType) => client.get<Term[]>(`termsBySection/${section}`);

export const getAllTermsBySection = () => client.get<Term[]>("termsBySection/all");

export const getDocs = () => client.get<Term[]>("getDocs");
